export function getQueryParam(prop: string) {
	const params: { [key: string]: string } = {};
	const search = decodeURIComponent(
		window.location.href.slice(window.location.href.indexOf("?") + 1)
	);
	const definitions = search.split("&");

	definitions.forEach(function (val: string) {
		const parts = val.split("=", 2);
		params[parts[0]] = parts[1];
	});

	return prop && prop in params ? params[prop] : "";
}

//Format for display whole number and number with decimal with comma
export function processNumValue(num: any, decimalPlaces: number = 2) {
	if (isNullOrUndefined(num) || isNaN(num)) {
		return (0).toFixed(decimalPlaces);
	}

	return Number(num).toLocaleString(undefined, {
		minimumFractionDigits: decimalPlaces,
		maximumFractionDigits: decimalPlaces,
	});
}

export const isNullOrUndefined = (value: any): boolean => {
	return value === null || value === undefined || value === "";
};

// ELLIPSIS USER METAMASK ADDRESS
export function trimAddress(address: string) {
	let trimAddress: string;
	if (address) {
		trimAddress =
			address.substring(0, 6) + "****" + address.substring(address.length - 4);
		return trimAddress;
	} else {
		return "-";
	}
}

export function isValidEmail(value: string) {
	// Regular expression for a basic email format
	const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}$/;
	return emailPattern.test(value);
}

export function abbreviateNumber(number) {
	const SI_SYMBOL = ["", "K", "M", "B", "T"];
	const tier = (Math.log10(Math.abs(number)) / 3) | 0;

	if (tier == 0) return number;

	const suffix = SI_SYMBOL[tier];
	const scale = Math.pow(10, tier * 3);
	const scaled = number / scale;

	return scaled.toFixed(2) + suffix;
}

export function clearLocalStorageExceptRemember() {
	const keysToPreserve = [
		"rememberUsernamePassword",
		"rememberUsername",
		"rememberPassword",
	];
	const preservedValues: { [key: string]: string } = {};

	// Store the values we want to preserve
	keysToPreserve.forEach((key) => {
		const value = localStorage.getItem(key);
		if (value !== null) {
			preservedValues[key] = value;
		}
	});

	// Clear all localStorage
	localStorage.clear();

	// Restore the preserved values
	Object.keys(preservedValues).forEach((key) => {
		localStorage.setItem(key, preservedValues[key]);
	});
}

// Tracks which casino/hub combos already have the script loaded,
// so repeat clicks on the same casino don't re-fetch it.
const loadedPlaytechScripts = new Set<string>();

export function loadPlaytechScript(
	mobileHub: string,
	casino: string
): Promise<void> {
	const key = `${mobileHub}:${casino}`;
	if (loadedPlaytechScripts.has(key)) {
		return Promise.resolve();
	}
	return new Promise((resolve, reject) => {
		const script = document.createElement("script");
		script.src = `https://login-ag.${mobileHub}.com/jswrapper/integration.js.php?casino=${casino}`;
		script.async = true;
		script.onload = () => {
			loadedPlaytechScripts.add(key);
			resolve();
		};
		script.onerror = () =>
			reject(new Error("Failed to load Playtech integration script"));
		document.head.appendChild(script);
	});
}

// function calloutLogin(callback: (response: any) => void) {
// }

// Wraps the callback-based iapiLoginAndGetTempToken in a Promise,
// with a timeout since the callback might never fire (network issue,
// blocked postMessage, misconfigured casino, etc.)
export function playtechLoginAndGetTempToken(
	username: string,
	password: string,
	language: string,
	systemId: string,
	realMode = 1,
	timeoutMs = 60000
): Promise<any> {
	return new Promise((resolve, reject) => {
		let settled = false;
		// Set a timeout to reject the promise if the login takes too long
		const timer = setTimeout(() => {
			if (!settled) {
				settled = true;
				reject(new Error("Playtech login timed out"));
			}
		}, timeoutMs);

		// @ts-ignore - iapiSetCallout/iapiLoginAndGetTempToken are defined globally by integration.js.php
		//iapiSetCallout("LoginAndGetTempToken", calloutLogin)
		// Set the callback for the login response
		iapiSetCallout("LoginAndGetTempToken", (response: any) => {
			if (settled) return;
			settled = true;
			clearTimeout(timer);
			resolve(response);
		});
		// @ts-ignore
		// Call the Playtech login function
		iapiLoginAndGetTempToken(username, password, realMode, language, systemId);
	});
}
